import { MetadataContent } from '@jutro/legacy/uiconfig';
import { MLDocumentTable } from 'ml-components-common-react';

import metadata from './MLClaimDetailsDocsReceived.metadata.json5';
import './MLClaimDetailsDocsReceived.messages';

import React from 'react';

function MLClaimDetailsDocsReceived(props) {
    const {
        docs
    } = props;

    const overrides = {
        documentTable: {
            documents: docs
        }
    };
    const resolvers = {
        resolveClassNameMap: {},
        resolveComponentMap: {
            MLDocumentTable
        },
        resolveCallbackMap: {
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

export default MLClaimDetailsDocsReceived;
